import React, { Fragment, useEffect } from "react";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import { useSelector, useDispatch } from "react-redux";
import { useParams /* , Link  */ } from "react-router-dom";
import MainContainer from "pages/_components/MainContainer";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { actions as discountsActions, actions as DiscountsActions } from "reducers/discounts";

import Loader from "pages/_components/Loader";
import Button from "pages/_components/Button";
import Notification from "pages/_components/Notification";
import CustomText from "pages/_components/CustomText/CustomText";
import Action from "pages/_components/Action";

import { getStatusTagColor } from "util/discounts";
import InfoTag from "pages/echeck/components/InfoTag";
import * as i18n from "util/i18n";
import { bool } from "prop-types";
import { isIOS } from "react-device-detect";
import Image from "pages/_components/Image";
import DataDetailDiscounts from "./_components/DataDetailDiscounts";

const DetailEcheqDiscounts = ({ isDesktop }) => {
    const { fetching, fetchingDownload, transactionsEcheqDiscount } = useSelector((state) => state.discounts);
    const { id, echeqNumber } = useParams();
    const { componentRef, handlePrint } = useReactPrint("detail.echeq.title");

    const dispatch = useDispatch();

    const dataLot = transactionsEcheqDiscount?.find((item) => item.idTransaction === id);

    /* const fileId = transaction?.file[0]?.fileId; */
    useEffect(() => {
        const data = {
            dateFrom: null,
            dateTo: null,
            pageNumber: 1,
            status: "",
            idBatch: "",
        };
        dispatch(DiscountsActions.setDiscountFilters({ ...data }));
        dispatch(DiscountsActions.loadListDiscountRequest());
        dispatch(discountsActions.getTransaction(id, true));
        dispatch(
            discountsActions.loadListEcheqLotRequest({
                id,
                pageNumber: 1,
                status: "TODOS",
                /* fileId, */
            }),
        );
    }, []);

    if (fetching) {
        return <Loader />;
    }

    /* const handleClickDonload = () => {
        dispatch(discountsActions.downloadDocument(fileId));
    }; */

    const handleDownload = () => {
        // dispatch(discountsActions.downloadFileEcheqDetail(dataLot.idTransaction, echeqNumber, dataLot.idBatch));
        handlePrint();
    };

    const State = () => (
        <InfoTag
            tagClass="discounts-echeq-tag__status ml-5"
            type="info"
            message={dataLot?.statusLabel}
            tagBackground={getStatusTagColor(dataLot?.status)}
        />
    );

    return (
        <Fragment>
            <Notification scopeToShow="detailDiscounts" />

            <ResponsiveHeader id="detail.echeq.title" infoComponents={<State />}>
                {/* <InfoTag
                    type="info"
                    message={getCodeMsg(dataLot?.status)}
                    tagBackground={statusTagColor(getCodeMsg(dataLot?.status))}
                /> */}
                <DesktopButtons>
                    <Button
                        onClick={() => handleDownload()}
                        className="btn btn-outline"
                        bsStyle="link"
                        image="images/figma/icon/download.svg"
                        label="global.download"
                        loading={fetchingDownload || fetching}
                    />
                </DesktopButtons>

                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action labelKey="global.download" handleClick={() => handleDownload()} />
                </MobileButtons>
            </ResponsiveHeader>

            <MainContainer showLoader={fetching}>
                <div className="container transaction-detail" ref={componentRef}>
                    <div className="show-print">
                        <div className="voucher-header">
                            <Image src="images/logoCompany.svg" />
                            <div
                                className="bibank-data"
                                dangerouslySetInnerHTML={{ __html: i18n.get("report.bibank.header") }}
                            />
                        </div>
                    </div>
                    <div
                        className={
                            isIOS
                                ? "media-object media-object-ios column show-print-fix"
                                : "media-object column show-print-fix"
                        }>
                        <div className="text-center">
                            <h1>
                                {i18n.get("detail.echeq.title")} <State />
                            </h1>
                        </div>
                    </div>
                    <div className="detail-discount-breadcrumb">
                        <CustomText textType="TEXT" text={`ID de Lote: `} />
                        <CustomText textType="data-label" text={`${dataLot?.idBatch} `} />
                        /
                        <CustomText className="f-weight-b" textType="data-label" text={` ID de Echeq: `} />
                        <CustomText className="f-weight-b" textType="data-label" text={`${echeqNumber} `} />
                    </div>

                    <DataDetailDiscounts isDesktop={isDesktop} />
                    <div className="discounts-echeq-simulation__rate">
                        <CustomText
                            text={`* ${i18n.get(
                                "discounts.simulation.taxRateDescription",
                                "Tasa Nominal Anual Adelantada.",
                            )}`}
                        />
                    </div>
                    <div className="discounts-echeq-simulation__rate">
                        <CustomText
                            text={`* ${i18n.get(
                                "discounts.amountToCredit.echeq.disclaimer",
                                "Neto a acreditar sujeto a impuesto de IVA, percepción de IVA, sellos e IIBB.",
                            )}`}
                        />
                    </div>
                </div>
            </MainContainer>
        </Fragment>
    );
};

DetailEcheqDiscounts.propTypes = {
    isDesktop: bool.isRequired,
};
export default DetailEcheqDiscounts;
